import React from "react";
import "./index.scss"; // Assurez-vous que le fichier CSS est bien lié
import pour1 from "../../assets/pour1.png";
import pour2 from "../../assets/pour2.png";
import pour3 from "../../assets/pour3.png";
import AppButton from "../appButton";
import { useNavigate } from "react-router-dom";
const cardData = [
  {
    id: 1,
    image: pour1,
    title:
      "Aider les enfants comme Abeba à lutter contre la faim et la malnutrition",
    description:
      "Votre don à la Fondation Junior MBUYI soutient des projets visant à améliorer les conditions de vie en milieu rural, notamment la construction d'écoles, de centres de santé et de systèmes d'approvisionnement en eau. Chaque contribution aide à créer un avenir plus stable et prospère pour les communautés vulnérables.",
  },
  {
    id: 2,
    image: pour2,
    title: "La joie de l'eau propre pour les enfants comme Marie",
    description:
      "Votre don soutient des projets agricoles durables visant à améliorer la sécurité alimentaire et l'autosuffisance des communautés rurales. En fournissant les outils et ressources nécessaires, vous aidez à lutter contre la malnutrition et à offrir des solutions durables pour nourrir ceux qui en ont besoin.",
  },
  {
    id: 3,
    image: pour3,
    title: "Aider les mères comme Kofi",
    description:
      "Les dons à la Fondation Junior MBUYI apportent des solutions concrètes aux populations vulnérables en leur fournissant les ressources nécessaires à leur développement. Votre générosité crée des opportunités durables et améliore la vie de milliers de personnes, offrant ainsi un avenir meilleur aux plus démunis.",
  },
];

const PourquoiDon = () => {
  const navigate = useNavigate();
  return (
    <section className="section-container-p">
      {/* Div en haut avec les titres */}
      <div className="top-content-p">
        <div>
          <h3 className="small-title-p">JM Foundation</h3>
          <h1 className="big-title-p">Pourquoi nous faire un don ?</h1>
        </div>
      </div>
      <div className="card-list">
        {cardData.map((card) => (
          <div className="card-p" key={card.id}>
            <img src={card.image} alt={card.title} className="card-image" />

            <p className="card-description">{card.description}</p>
          </div>
        ))}
      </div>
      <div className="btn-container">
        <AppButton
          text="CONTACTEZ-NOUS"
          color="bleu"
          className="width_mobile"
          size="large"
          onClick={() => {
            navigate("/contact");
            window.scrollTo(0, 0);
          }}
        />
        <AppButton
          text="Faire un don"
          color="orange"
          className="width_mobile width-total1 "
          size="large"
          onClick={() => {
            navigate("/faire-don");
            window.scrollTo(0, 0);
          }}
        />
      </div>
    </section>
  );
};

export default PourquoiDon;
